<template>
  <div class="sourcing">
    <div class="page-content">
      <div class="container">
        <div class="sourcing-features">
          <div class="sourcing-features-left">
            <div class="sourcing-features-left-title">
              {{ $t('solutions.sourcing') }}
            </div>
            <div class="sourcing-features-left-subtitle">
              {{ $t('solutions.sourcing.title') }}
            </div>
            <div class="sourcing-features-sub-icon">
              <div class="sourcing-features-sub-icon-list">
                <img class="sourcing-features-sub-icon-info" src="@/assets/images/sourcing-title-1.png" alt="">
                <div class="sourcing-features-sub-icon-title">{{ $t('solutions.sourcing.clothing') }}</div>
              </div>
              <div class="sourcing-features-sub-icon-list">
                <img class="sourcing-features-sub-icon-info" src="@/assets/images/sourcing-title-4.png" alt="">
                <div class="sourcing-features-sub-icon-title">{{ $t('solutions.sourcing.pet') }}</div>
              </div>
              <div class="sourcing-features-sub-icon-list">
                <img class="sourcing-features-sub-icon-info" src="@/assets/images/sourcing-title-3.png" alt="">
                <div class="sourcing-features-sub-icon-title">{{ $t('solutions.sourcing.luggage') }}</div>
              </div>

              <div class="sourcing-features-sub-icon-list">
                <img class="sourcing-features-sub-icon-info" src="@/assets/images/sourcing-title-2.png" alt="">
                <div class="sourcing-features-sub-icon-title">{{ $t('solutions.sourcing.tools') }}</div>
              </div>
            </div>
            <div class="sourcing-content-text">
              {{ $t('solutions.sourcing.content') }}
            </div>
          </div>
          <div class="sourcing-features-right">
            <img class="sourcing-main-info" src="@/assets/images/sourcing-main.png" alt="">
          </div>
        </div>
        <div class="main-content">
          <div class="main-content-1">
            <div class="main-content-img">
              <img class="desktop-img" src="@/assets/images/sourcing/content-1.png" alt=""/>
              <img class="mobile-img" src="@/assets/images/sourcing/content-mobile-1.png" alt=""/>
            </div>
            <div class="main-content-content-text">
              <div class="main-content-content-text-title">
                {{$t('solutions.sourcing.competitive_price')}}
              </div>
              <div class="main-content-content-text-content">
                {{$t('solutions.sourcing.competitive_price_content')}}
              </div>
            </div>
          </div>
          <div class="main-content-1">

            <div class="main-content-content-text main-content-odd">
              <div class="main-content-content-text-title">
                {{$t('solutions.sourcing.prompt_quotation_service')}}
              </div>
              <div class="main-content-content-text-content">
                {{$t('solutions.sourcing.prompt_quotation_service_content')}}
              </div>
            </div>
            <div class="main-content-img">
              <img class="desktop-img" src="@/assets/images/sourcing/content-2.png" alt=""/>
              <img class="mobile-img" src="@/assets/images/sourcing/content-mobile-2.png" alt=""/>
            </div>
          </div>
          <div class="main-content-1">
            <div class="main-content-img">
              <img class="desktop-img" src="@/assets/images/sourcing/content-3.png" alt=""/>
              <img class="mobile-img" src="@/assets/images/sourcing/content-mobile-3.png" alt=""/>
            </div>
            <div class="main-content-content-text">
              <div class="main-content-content-text-title">
                {{$t('solutions.sourcing.supply_chain_expertise')}}
              </div>
              <div class="main-content-content-text-content">
                {{$t('solutions.sourcing.supply_chain_expertise_content')}}
              </div>
            </div>
          </div>
        </div>
        <div class="blank_info"></div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'SourcingPage'
}
</script>

<style scoped>
.container {
  max-width: 75rem;
  margin: 0 auto;
  padding: 0 2rem;
}

.sourcing-features {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  margin-top: 13.56rem;
  justify-content: space-between;
  align-items: center;

}


.sourcing-features-left-title {
  opacity: 1;
  font-size: 40px;
  font-weight: bold;
  color: #64B800;

}

.sourcing-features-left-subtitle {
  opacity: 1;
  font-size: 20px;
  font-weight: 500;
  color: #353534;
  margin-top: 1.25rem;
}

.sourcing-features-left {
  display: flex;
  flex-direction: column;
  width: 23.8rem;

}

.sourcing-features-sub-icon {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  margin-top: 1.25rem;
}

.sourcing-features-sub-icon-list {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
}

.sourcing-features-sub-icon-info {
  width: 2.5rem;
  height: 2.5rem;
}

.sourcing-features-sub-icon-title {
  font-size: 16px;
  font-weight: 500;
  color: #353534;
  margin-top: 0.44rem;
  text-align: center;
}

.sourcing-content-text {
  margin-top: 2.68rem;
  font-size: 16px;
  font-weight: normal;
  color: #797979;
  text-indent: 2em;
}

.sourcing-features-right {
  display: flex;
}

.sourcing-main-info {
  width: 32rem;
}

.main-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 8.75rem auto 0;
  gap: 3.75rem;
}

.main-content-1 {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  /* height: 22.5rem; */
  border-radius: 16px;
  opacity: 1;
  background: #F4F4F4;
  justify-content: space-between;
}



.main-content-img {
  width: 28.75rem;
  height: 22.5rem;
  position: relative;
}

/* PC端显示桌面图片，隐藏移动端图片 */
.desktop-img {
  display: block;
  width: 100%;
  height: 100%;
}

.mobile-img {
  display: none;
}

.main-content-content-text {
  display: flex;
  flex-direction: column;
  width: 28.81rem;
  justify-content: center;
  margin-right: 3.69rem;
}

.main-content-content-text-title {
  font-size: 35px;
  font-weight: bold;
  color: #353534;
  text-align: left;
}

.main-content-content-text-content {
  font-size: 16px;
  font-weight: normal;
  color: #353534;
  margin-top: 1.94rem;
  text-indent: 2em;
}

.blank_info {
  height: 10rem;
}

.main-content-odd {
  margin-right: 0;
  margin-left: 3.69rem;
}

@media (max-width: 1024px) {
  .sourcing-features {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    margin-top: 5.56rem;
    justify-content: space-between;
    align-items: center;

  }

  .sourcing-features-left-title {
    opacity: 1;
    font-size: 40px;
    font-weight: bold;
    color: #64B800;
    text-align: center;

  }

  .sourcing-features-right {
    display: flex;
    margin-top: 2.2rem;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 4rem auto 0;
    gap: 2rem;

  }

  .main-content-1 {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    opacity: 1;
    padding: 0;
    align-items: stretch;
    text-align: center;
    border-radius: 2px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.03)), #FFFFFF;
    overflow: hidden;
  }

  .main-content-img {
    width: 100%;
    height: 200px;
    margin: 0;
    overflow: hidden;
  }

  /* 移动端显示移动端图片，隐藏桌面图片 */
  .desktop-img {
    display: none;
  }

  .mobile-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .main-content-content-text {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    margin: 0;
    text-align: center;
    padding: 1.5rem;
  }

  .main-content-content-text-title {
    font-size: 1.2rem;
    font-weight: bold;
    text-align: center;
    color: #000000;
  }

  .main-content-content-text-content {
    font-size: 0.8rem;
    color: #353534;
    text-align: left;
    margin-top: 0.4rem;
  }

  .main-content-odd {
    margin: 0;
  }

  /* 移动端重新排序：确保所有内容都是图片在上，文案在下 */
  .main-content-1:nth-child(2) {
    display: flex;
    flex-direction: column;
  }

  .main-content-1:nth-child(2) .main-content-img {
    order: 1;
  }

  .main-content-1:nth-child(2) .main-content-content-text {
    order: 2;
  }
  .blank_info {
    height: 4rem;
  }
  .sourcing-features-left-subtitle {
  text-align: center;
}
.sourcing-content-text {
  text-indent: 2em;
}

}

</style>
